import $ from 'jquery';
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
// import UIHelper from './common/UIHelper';
// import App from './Routes';
import ReactPixel from 'react-facebook-pixel';
import CustomApp from './CustomRoutes';
// import App from './Routes_SellerType';
import store from './redux/store';
import SessionHelper from './common/SessionHelper';
import Constants from './common/Constants';
import CustomThemeProvider from './themes/CustomThemeProvider';
import {
	// register,
	unregister,
} from './registerServiceWorker';
import AjaxHelper from './common/AjaxHelper';
import PackageStore from './common/util/PackageStore';

import './css/index.css';
import './css/style.css';
import './css/daterangepicker.css';
import './css/search.css';

let language = ((navigator.languages && navigator.languages[0]) || navigator.language || 'en').toLocaleLowerCase().split(/[-_]/)[0];

const languageSupport = ['en', 'it', 'es', 'ja', 'ru', 'de'];

if (!languageSupport.includes(language)) {
	language = 'en';
}

const GAID = 'GAID';
const FACEBOOKPIXELID = 'FACEBOOKPIXELID';
// const options = {
// 	autoConfig: true, 	// set pixel's autoConfig
// 	debug: false, 		// enable logs
// };

const Root = ({ store }) => (
	<Provider store={store}>
		<BrowserRouter>
			<CustomThemeProvider>
				<CookiesProvider>
					<CustomApp />
				</CookiesProvider>
			</CustomThemeProvider>
		</BrowserRouter>
	</Provider>
);

async function rerender() {
	// console.log('Inside rerender');
	if (!SessionHelper.get('Constants.SESSION_HASHCODE')) {
		const hash = await AjaxHelper.invokeServerAPIPromise('/api/getHash', {});
		SessionHelper.set(Constants.SESSION_HASHCODE, hash);
	}
	const analyticsID = localStorage.getItem(GAID);
	const facebookPixelID = localStorage.getItem(FACEBOOKPIXELID);
	let foundGAID = false; let
		foundFacebookID = false;
	if (analyticsID) {
		window.ga('create', analyticsID, 'auto');
		foundGAID = true;
	}
	if (facebookPixelID) {
		ReactPixel.init(facebookPixelID);
		ReactPixel.pageView();
		foundFacebookID = true;
	}
	await PackageStore.loadPackages();

	if (PackageStore.isPackageSubscribed(Constants.PACKAGE_NAMESPACE_EXTERNAL_ANALYTICS) && (!foundGAID
			|| !foundFacebookID)) {
		try {
			const results = await AjaxHelper.invokeServerAPIPromise('/api/config', {
				'extanalytics.googleAnalyticsID': 1,
				'extanalytics.facebookPixelID': 1
			});
			// console.log('results ::',results, results['google.analytics.id']);
			if (!foundGAID) {
				window.ga('create', results['extanalytics.googleAnalyticsID'], 'auto');
				localStorage.setItem(GAID, results['extanalytics.googleAnalyticsID']);
			}
			if (!foundFacebookID) {
				ReactPixel.init(results['extanalytics.facebookPixelID']);
				ReactPixel.pageView();
				localStorage.setItem(FACEBOOKPIXELID, results['extanalytics.facebookPixelID']);
			}
		} catch (err) {
			console.log('error initializing google/facebook analytics', err);
		}
	} else {
		// console.log('PackageStore.isPackageSubscribed(Constants.PACKAGE_NAMESPACE_EXTERNAL_ANALYTICS) ::',
		// PackageStore.isPackageSubscribed(Constants.PACKAGE_NAMESPACE_EXTERNAL_ANALYTICS));
	}
	render(<Root store={store} />, document.getElementById('root'));
	insertAdditionalExternalJSFiles();
}

async function insertAdditionalExternalJSFiles() {
	const scripts = await AjaxHelper.invokeServerAPIPromise('/api/config', { externalScripts: 1, 'extanalytics.googleTagManagerHead': 1, 'extanalytics.googleTagManagerBody': 1 });
	if (scripts['extanalytics.googleTagManagerHead']) {
		$('head').append($(scripts['extanalytics.googleTagManagerHead']));
	}
	if (scripts['extanalytics.googleTagManagerBody']) {
		$('body').append($(scripts['extanalytics.googleTagManagerBody']));
	}
	if (scripts.externalScripts && scripts.externalScripts.trim().length > 0) {
		$('body').append($(scripts.externalScripts));
	}
}

rerender();
// register();
unregister();
